module.exports = "/images/blister-12.png";